module.exports = __webpack_public_path__ + "banner_text.ff6f4897.png";